import { keysToSnakeCaseDeep } from '@agro1desenvolvimento/utils-js';
import { Atividade, AtividadeTipo } from '../@types';
import aqilaApi from './aqila-api';

export type AtividadeToSave = {
  abreviatura: string;
  cor: string;
  corFonte: string;
  descricao: string;
  tipo: AtividadeTipo;
};

class Atividades {
  private readonly endpoint = 'v1/atividades';

  async list() {
    const { data } = await aqilaApi.get<Atividade[]>(this.endpoint);

    return data;
  }

  async find(id: string) {
    const { data } = await aqilaApi.get<Atividade>(`${this.endpoint}/${id}`);

    return data;
  }

  async create(record: AtividadeToSave) {
    await aqilaApi.post(
      this.endpoint,
      keysToSnakeCaseDeep({ atividade: record }),
    );
  }

  async update(record: AtividadeToSave & { id: string }) {
    await aqilaApi.patch(
      `${this.endpoint}/${record.id}`,
      keysToSnakeCaseDeep({ atividade: record }),
    );
  }

  async delete(id: string) {
    await aqilaApi.delete(`${this.endpoint}/${id}`);
  }

  isMilho(descricao?: string) {
    if (!descricao) return false;
    return descricao.toUpperCase().includes('MILHO');
  }
}

export default new Atividades();
